export interface SurveyIdentifiersModel {
  surveyId: string;
  participantId: string;
  surveyReference: string;
}
